import {
  HubConnectionBuilder,
  HubConnection,
  LogLevel,
  HubConnectionState,
} from "@microsoft/signalr";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:5000";

let connection: HubConnection | null = null;

export function getSignalRConnection(): HubConnection {
  if (connection) return connection;

  connection = new HubConnectionBuilder()
    .withUrl(`${API_URL}/hubs/dashboard`, {
      accessTokenFactory: () => localStorage.getItem("accessToken") || "",
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build();

  // Silence "No client method with the name 'X' found" warnings for admin
  // events that are conditionally consumed by per-page components (ActivityFeed
  // on /admin/overview). The connection is held open by the dashboard layout
  // for every admin page, but the consumer may not be mounted. SignalR allows
  // multiple handlers per event, so the per-page handlers still receive the
  // event when mounted; this no-op only fires when nothing else is listening.
  connection.on("admin.activity", () => {});

  return connection;
}

export async function startSignalR(): Promise<void> {
  const conn = getSignalRConnection();
  if (conn.state === HubConnectionState.Disconnected) {
    try {
      await conn.start();
    } catch (err) {
      console.error("SignalR connection failed:", err);
    }
  }
}

export async function stopSignalR(): Promise<void> {
  if (connection) {
    try {
      await connection.stop();
    } catch {
      // Ignore errors on stop
    }
    connection = null;
  }
}
